module.exports = __webpack_public_path__ + "img/z2.6718e3ae.jpeg";